import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Wrapper } from 'src/app/components/wrapper.component';
import { TabGroup } from '../../modules/manage/manage-wrapper.component';
import { AccountClipboardPage, EntityClipboard } from 'globals/store/accounts.data';
import { Entity } from 'globals/store/entity.data';
import { SocialLink } from 'globals/store/entity.shared.data';
import { imageUploaderDisplayTypes } from 'globals/store/files.model';
import { Sponsor } from 'globals/store/sponsors.data';
import { Performer } from 'globals/store/performers.data';
import { JoiResource } from 'globals/store/resources.data';
import { Dictionary } from '@ngrx/entity';
import { EntitiesService } from 'src/app/services/entities.service';

@Component({
    selector: 'manage-template-wrapper',
    template: '',
    standalone: true,
})
export class ManageTemplateWrapper<E extends Entity> extends Wrapper<ManageTemplateWrapper<E>> {

  _file = 'manage-template-wrapper'
  entity: E
  clipboardKey: keyof EntityClipboard
  tabGroups: TabGroup[] = [{ tabs: [
    { id: 'details', name: 'Template details' },
  ]}]
  selectedTab
  imageUploaderDisplayTypes = imageUploaderDisplayTypes
  clipboardPagesByAccount: Dictionary<Dictionary<AccountClipboardPage>>

  constructor(
    public dialogRef: MatDialogRef<ManageTemplateWrapper<E>>, 
    @Inject(MAT_DIALOG_DATA) public data: ManageTemplateData,
    public changeDetectorRef: ChangeDetectorRef,
    private entitiesService: EntitiesService,
    ) {
    super()
    this.subProp(this.store.select('accounts', 'clipboardPagesByAccount'), 'clipboardPagesByAccount')
  }

  updateTitle(newTitle: string) {
    this.entity.name = newTitle
    this.saveEntity()
  }

  changeTab(tab) {
    this.selectedTab = tab
  }
  
  changeImage(result, type: 'logo' | 'photo' | 'resource') {
    switch (type) {
      case 'logo':
      case 'resource':
        (this.entity as Sponsor | JoiResource).logoUrl = result ? result.thumbUrl : null;
        (this.entity as Sponsor | JoiResource).fullLogoUrl = result ? result.photoUrl : null;
        break
      case 'photo':
        (this.entity as Performer).photoUrl = result ? result.thumbUrl : null;
        (this.entity as Performer).fullPhotoUrl = result ? result.photoUrl : null;
        break
    }
    this.saveEntity()
  }

  saveSocialLinks(links: SocialLink[]) {
    (this.entity as Sponsor).social = links
    this.saveEntity()
  }

  exit() {
    this.dialogRef.close()
  }

  saveEntity() {
    this.entitiesService.saveTemplate(this.clipboardKey, this.entity, this.data.accountId, Object.values(this.clipboardPagesByAccount[this.data.accountId] || {}))
  }

  async delete() {
    this.entitiesService.deleteTemplates(this.clipboardKey, [this.entity.id], Object.values(this.clipboardPagesByAccount[this.data.accountId] || {}))
    this.dialogRef.close()
  }
}

export interface ManageTemplateData {
  entityId: string
  accountId: string
}
